// ===================================
// NOT FOUND PAGE (404)
// src/pages/NotFound.js
// Styled 404 page for the app
// ===================================

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './NotFound.css';

const NotFound = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  // Determine where to redirect based on auth status
  const homeLink = isAuthenticated 
    ? (user?.is_admin ? '/admin/dashboard' : '/app/dashboard')
    : '/';

  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1>Page Not Found</h1>
        <p className="error-message">
          The page <code>{location.pathname}</code> doesn't exist or has been moved.
        </p>
        
        <div className="not-found-actions">
          <Link to={homeLink} className="btn btn-primary">
            ← Go to {isAuthenticated ? 'Dashboard' : 'Home'}
          </Link>
          
          {isAuthenticated && (
            <>
              <Link to="/app/book" className="btn btn-secondary">
                Book a Session
              </Link>
              <Link to="/app/sessions" className="btn btn-secondary">
                View Sessions
              </Link>
            </>
          )}
          
          {!isAuthenticated && (
            <>
              <Link to="/login" className="btn btn-secondary">
                Login
              </Link>
              <Link to="/register" className="btn btn-secondary">
                Sign Up
              </Link>
            </>
          )}
        </div>

        <div className="helpful-links">
          <h3>Helpful Links</h3>
          <ul>
            {isAuthenticated ? (
              <>
                <li><Link to="/app/dashboard">📊 Dashboard</Link></li>
                <li><Link to="/app/book">📅 Book Session</Link></li>
                <li><Link to="/app/sessions">📋 My Sessions</Link></li>
                <li><Link to="/app/progress">📈 Progress</Link></li>
                <li><Link to="/app/settings">⚙️ Settings</Link></li>
                {user?.is_admin && (
                  <li><Link to="/admin/dashboard">🔧 Admin Panel</Link></li>
                )}
              </>
            ) : (
              <>
                <li><Link to="/">🏠 Home</Link></li>
                <li><Link to="/login">🔑 Login</Link></li>
                <li><Link to="/register">✨ Get Started</Link></li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;